module.exports = __webpack_public_path__ + "media/images/emblems/Zetzwil-blason-8a6272e2c6d54e125940c43b5e761908.png";